
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.877 7.467c.232.231.468.466.673.733l-.05.01c.33.38.6.79.8 1.25l.13.26c.95 2.28.3 4.94-1.5 6.6-1.61 1.48-3.86 1.87-5.96 1.6-1.97-.25-3.8-1.49-4.84-3.22-.32-.53-.58-1.13-.72-1.73-.17-.5-.23-1-.27-1.5C0 9.3.89 7 2.53 5.64c-.75 1.64-.57 3.69.53 5.12.05.07.09.12.15.17.18.16.42.22.64.12.2-.08.35-.28.35-.5 0-.13-.04-.23-.08-.33-1.2-3.15-.2-6.82 2.34-8.9C7.16.75 8 .23 8.91 0 8 1.85 8.3 4.26 9.76 5.72c.341.341.718.624 1.095.907.319.24.637.478.935.753l.087.087zM8.37 15.1c.35-.1.8-.36 1.08-.6h-.01c.6-.55.95-1.45.92-2.27 0-.15-.02-.29-.06-.43-.163-.885-.723-1.38-1.304-1.894C8.683 9.63 8.366 9.35 8.1 9c-.23-.3-.43-.68-.6-1.06-.28.69-.3 1.32-.18 2.06.037.221.09.433.14.642.128.518.251 1.018.13 1.588-.2.89-.9 1.77-2.09 2.05.67.66 1.77 1.22 2.87.82z","fill":"#38393A"}})])
          )
        }
      }
    